export default {
  payment_methods: {
    card: 'Credit Card',
    sofort: 'Sofort',
    giropay: 'Giropay',
    iban: 'EC-Card / IBAN',
    cash: 'Cash',
  },
};
